// on importe le controller car les components angularJS
// permettent l'ajout direct d'une fonction dans la propriété "controller"
import ImageCaracteristiquesController from './image.form.caracteristiques.controller';
import Template from './image.form.caracteristiques.html';

export default {
	bindings: {
		// on bind avec '=' (double binding)
		// quand on veut pouvoir modifier l'objet des deux cotés (appelant et component)
		image: '=',
		// on bind avec '<' (binding one way)
		// quand on ne veut pas pouvoir modifier l'objet dans le component (seulement dans l'appelant)
		idType: '<',
		onUpdate: '&',
		form: '=',
		onCaracteristiquesCount: '&'
	},
	template: Template /* require('./image.form.caracteristiques.html') */,
	controller: ImageCaracteristiquesController
	// si on ne déclare pas de 'controllerAs', par défaut ce sera '$ctrl'
};
